// src/components/Assets/Templates/Normal1/normal1.js
export default `
 
<!doctype html>
<html ⚡4email data-css-strict>
<head>
<meta charset="utf-8">

<script async src="https://cdn.ampproject.org/v0.js"></script> 

<script async custom-element="amp-lightbox" src="https://cdn.ampproject.org/v0/amp-lightbox-0.1.js"></script>
<style amp4email-boilerplate>
body {
visibility: hidden;
}
</style>
<style amp-custom>
.sec1{
position: absolute;
top: 43%;
right: 38%;
}
.sec1-btn2{
position: absolute;
top: 60%;
right: 46.4%;
border: 1px solid #000000;
padding: 6px 10px;
background-color: white;
font-size: 16px;
font-weight: bold;
margin: 10px;

}
.section1{
background-color: #F38486;
padding: 30px 30px 30px 30px;
border-radius: 20px;
}
.btn1{
border: 0px;
padding: 12px 20px;
background-color: black;
color: white;
font-size: 14px;
font-weight: bold;
border-radius: 8px;
margin: 20px 0px;
}
.sec2{
width: 600px;
height: auto;
position: absolute;
right: 23.7%;
top: 1%;
padding-bottom: 300px;
}
.section2{
background-color: #000;
padding: 50px 20px 10px 20px;
}
.sec2-btn2{
position: absolute;
top: 2.5%;
right: 27%;
border: 1px solid #000000;
padding: 6px 10px;
background-color: white;
font-size: 16px;
font-weight: bold;
margin: 10px;
}

.section_inside{
background-color: #F38486;
padding: 30px 30px 30px 30px;
border-radius: 20px;
}
.sec_inside{
position: absolute;
top: 70%;
right: 38.5%;
}
.sec1-btn_inside{
position: absolute;
top: 87%;
right: 48%;
border: 1px solid #000000;
padding: 6px 10px;
background-color: white;
font-size: 16px;
font-weight: bold;
margin: 10px;
}
.btn_inside{
border: 0px;
padding: 12px 20px;
background-color: white;
color: black;
font-size: 14px;
font-weight: bold;
border-radius: 8px;
margin: 20px 0px;
}



/*    accordion*/
.header{
cursor: pointer;
background-color: #BB7AEC;
padding: 10px 0px;
text-align: center;
}
.tog{
cursor: pointer;
display: block;
background-image: url('https://cdn0.iconfinder.com/data/icons/google-material-design-3-0/48/ic_add_circle_48px-512.png');
background-repeat: no-repeat;
background-size: 26px auto;
background-position: 96% 50%;
}
.cont{
color: #ffffff;
padding: 10px 30px;
font-size: 18px;
font-family: "Times New Roman", "serif";
}
.sec3-img{
margin-right: 20px;
}

/*    carousel*/
.amp-carousel-button-prev {
left: 16px;
background-image: url('https://hosting.cbdeals.in/SonyLIV_STI_AMP/images/arr_left.png');
background-size: 18px 18px;
}
.amp-carousel-button-next {
right: 16px;
background-image: url('https://hosting.cbdeals.in/SonyLIV_STI_AMP/images/arr_right.png');
background-size: 18px 18px;
}
.amp-carousel-button {
position: absolute;
box-sizing: border-box;
top: 50%;
height: 34px;
width: 34px;
border-radius: 2px;
opacity: 0;
background-color: rgba(0,0,0,0);
background-position: 50% 50%;
background-repeat: no-repeat;
transform: translateY(-50%);
visibility: hidden;
z-index: 10;
}
.amp-carousel-button:focus {
border: 0px solid #000;
outline: 0px solid #fff;
}
.modal{
position: fixed ;
top: 0;
left: 0 ;
bottom: 0 ;
right: 0 ;
}
.modal1{
position: absolute;
top: 40%;
left: 0%;
bottom: 0;
right: 0;
width:600px;
height:auto;
margin:0 auto;
} 

#btn{height:30px;
width: 30px;
background-color: black;
color: white;}


@media only screen and (max-width: 600px) {
.w100 {
width: 100%;
}
.w-100 {
width: 100%; max-width: 100%;
}
.w320{width: 320px;}
.sec1{
position: absolute;
top: 34%;
right: 4%;
}
.sec1-btn2{
position: absolute;
top: 51.8%;
right: 38.4%;
border: 1px solid #000000;
padding: 6px 10px;
background-color: white;
font-size: 16px;
font-weight: bold;
margin: 10px;
}
.sec2{
width: 320px;
height: auto;
position: absolute;
left: -37px;
top: 14px;
}
.section2{
background-color: #000;
padding: 50px 0px 10px 0px;
}
.sec2-btn2{
position: absolute;
top: 2%;
right: 1%;
border: 1px solid #000000;
padding: 6px 14px;
background-color: white;
font-size: 16px;
font-weight: bold;
margin: 10px;
}
.sec_inside{
position: absolute;
top: 38%;
right: 4%;
}
.sec1-btn_inside{
position: absolute;
top: 56%;
right: 41%;
border: 1px solid #000000;
padding: 6px 10px;
background-color: white;
font-size: 16px;
font-weight: bold;
margin: 10px;
}
.sec3-img{
margin-right: 0px; margin-bottom: 20px;
}
.mob{float: left; display: block; width: 100%;}

.amp-carousel-button-prev {
left: -2px;
background-image: url('https://hosting.cbdeals.in/SonyLIV_STI_AMP/images/arr_left.png');
background-size: 16px 16px;
}
.amp-carousel-button-next {
right: -2px;
background-image: url('https://hosting.cbdeals.in/SonyLIV_STI_AMP/images/arr_right.png');
background-size: 16px 16px;
}
.modal{
position: fixed ;

top: 0;
left: 0 ;
bottom: 0 ;
right: 0 ;
}
.modal1{
position: absolute;
top: 40%;
left: 0%;
bottom: 0;
right: 0;
width:200px;
height:auto;
margin:0 auto;
}	

}

</style>
<!--    </style>-->
</head>

<body style="margin-top:0px; margin-bottom:0px; background-color: #e8e8e8;">
<table align="center" width="100%" style="width: 100%;" >
<tbody>
<tr>
<td style="display:none; visibility:hidden;font-size:1px; color:#f4f4f4; line-height:1px; max-height:0px; max-width:0px; opacity:1; overflow:hidden;" align="center">Srihari Muppalla</td>
</tr>
<tr> 
<td align="center" class="hide" valign="top"><span style="font-family: Arial, Helvetica, sans-serif; font-size: 2px; color: #ffffff; font-weight: normal; visibility:hidden;"> &zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;</span></td>
</tr>
<tr>
<td><table width="600" border="0" cellspacing="0" cellpadding="0" align="center" class="w100" style="border: 1px solid #333333;"  bgcolor="#ffffff">
<tbody>
<tr><td class="darkmode" style="padding: 20px 0px; font-size: 26px; line-height: 30px; font-family: Arial, Helvetica, sans-serif; text-align: center; font-weight: bold; background-color: #352685; color: #ffffff;">Srihari Muppalla</td></tr>
<tr>
<td>
<table width="90%" border="0" cellspacing="0" cellpadding="0" align="center">
<tbody>
<tr>
<td align="center" style="padding: 20px 0px 0px 0px;">
<a href="https:srihari.site" target="_blank"><amp-img src="https://placehold.co/600x300/352685/FFFFFF/png" layout="responsive" alt="Shesham" title="Shesham" width="600" height="300"></amp-img></a>
</td>
</tr>
<tr><td valign="top"><p style="margin:0px; font-family: Arial; font-size: 16px; line-height: 24px; font-weight: normal; text-align: left;  color: #333333; margin-top: 25px;" class=" ">Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
<p style="margin:0px; font-family: Arial; font-size: 16px; line-height: 24px; font-weight: normal; text-align: left;  color: #333333; margin-top: 15px;" class=" ">
Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
<p style="margin:0px; font-family: Arial; font-size: 16px; line-height: 24px; font-weight: normal; text-align: left;  color: #333333; margin-top: 15px;" class=" ">
Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
</td>
</tr>
<!--First lightbox-->
<tr>
<td align="center">
<button on="tap:quote-lb" class="btn1">Subscribe Here!</button>
<amp-lightbox id="quote-lb" layout="nodisplay">
<blockquote>
<div class="modal amp-lightbox">
<div class="modal1">
<table bgcolor="#f1f1f1" width="300" align="center" border="0" cellspacing="0" cellpadding="0" style="width: 300px;" class="w-100">
<tbody>
<tr>
<td align="center" valign="top">
<table width="80%" align="center" border="0" cellspacing="0" cellpadding="0">
<tbody>
<tr>
<td align="right" style="padding: 20px 0px 10px 10px;"> <button on="tap:quote-lb.close" id="btn"  role="button" tabindex="0">X</button></td></tr>
<tr>
<td align="center" valign="top"> <amp-img src="https://t4.ftcdn.net/jpg/01/15/20/75/360_F_115207580_US2etunH78I7iMYHOoNVvxQTCIdoPdRj.jpg" width="300" height="200" layout="responsive" alt="Srihari"></amp-img></td>
</tr>
<tr>
<td align="center" valign="top">
<table width="90%" align="center" border="0" cellspacing="0" cellpadding="0">
<tbody>
<tr>
<td align="center" valign="top"><p style="font-size: 18px;">Subscribed Successsfully</p></td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
</div>
</blockquote>
</amp-lightbox>
</td>
</tr>
<!--First lightbox-->
</tbody>
</table>     
</td>
</tr>
<tr>
<td bgcolor="#352685" style="text-align: center; font-size:18px; padding: 10px 0px; font-family:Lato,Arial,sans-serif; line-height:21px; height: 25px; color: #ffffff;" > Srihari Muppalla </td>
</tr>
</tbody>
</table></td>
</tr>
</tbody>
</table>
</body>
</html>

`;